/**
 * Cart upsell sidebar - drag + prev/next arrows.
 * Same click/drag thresholds as cart-upsell-slider.
 */
(function () {
  const CLICK_THRESHOLD = 8;
  const DRAG_THRESHOLD = 30;

  function initSidebar(sidebar) {
    if (sidebar.dataset.cartUpsellSidebarInit) return;
    sidebar.dataset.cartUpsellSidebarInit = 'true';
    const wrap = sidebar.querySelector('[data-cart-upsell-sidebar-track-wrap]');
    const track = sidebar.querySelector('[data-cart-upsell-sidebar-track]');
    const prevBtn = sidebar.querySelector('[data-cart-upsell-prev]');
    const nextBtn = sidebar.querySelector('[data-cart-upsell-next]');
    if (!track || !wrap) return;

    let startX = 0;
    let scrollLeft = 0;
    let moved = 0;
    let isDragging = false;
    let active = false;

    function onPointerDown(e) {
      if (!track.contains(e.target) || e.target.closest('button') || e.target.closest('select')) return;
      startX = e.clientX ?? e.touches?.[0]?.clientX ?? 0;
      scrollLeft = track.scrollLeft;
      moved = 0;
      isDragging = false;
      active = true;
      document.addEventListener('pointermove', onPointerMove, { passive: false });
      document.addEventListener('touchmove', onPointerMove, { passive: false });
      document.addEventListener('pointerup', onPointerUp);
      document.addEventListener('touchend', onPointerUp);
      document.addEventListener('pointercancel', onPointerUp);
    }

    function onPointerMove(e) {
      if (!active) return;
      const x = e.clientX ?? e.touches?.[0]?.clientX ?? 0;
      const dx = x - startX;
      moved = Math.abs(dx);
      if (moved >= CLICK_THRESHOLD) isDragging = true;
      if (moved >= DRAG_THRESHOLD) {
        track.scrollLeft = scrollLeft - dx;
        e.preventDefault();
      }
    }

    function onPointerUp() {
      active = false;
      document.removeEventListener('pointermove', onPointerMove);
      document.removeEventListener('touchmove', onPointerMove);
      document.removeEventListener('pointerup', onPointerUp);
      document.removeEventListener('touchend', onPointerUp);
      document.removeEventListener('pointercancel', onPointerUp);
    }

    function onTrackClick(e) {
      if (isDragging || moved >= CLICK_THRESHOLD) {
        e.preventDefault();
        e.stopPropagation();
      }
    }

    track.addEventListener('pointerdown', onPointerDown, { passive: true });
    track.addEventListener('touchstart', onPointerDown, { passive: true });
    track.addEventListener('click', onTrackClick, { capture: true });
    track.addEventListener('dragstart', (e) => e.preventDefault());
    track.addEventListener('drag', (e) => e.preventDefault());

    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        const step = wrap.offsetWidth * 0.8;
        track.scrollLeft = Math.max(0, track.scrollLeft - step);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        const step = wrap.offsetWidth * 0.8;
        track.scrollLeft = Math.min(track.scrollWidth - wrap.offsetWidth, track.scrollLeft + step);
      });
    }

    track.querySelectorAll('img').forEach((img) => {
      img.setAttribute('draggable', 'false');
      img.addEventListener('dragstart', (e) => e.preventDefault());
    });
  }

  function init() {
    document.querySelectorAll('[data-cart-upsell-sidebar]').forEach(initSidebar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.initCartUpsellSidebar = init;
})();
